import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import OrderActions from "./OrderActions";
import { styled } from "@mui/material/styles";
import { RoleData } from "types/models/master/MasterApp";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
}));

interface TableItemProps {
  data: RoleData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {

  const getStatusColor = () => {
    switch (data.isActive) {
      case 1:
        return "#43C888";
      case 0:
        return "#F84E4E";
      default:
        return "#E2A72E";
    }
  };

  return (
    <>
      <TableRow key={data.role} className="item-hover">
        <StyledTableCell align="left">
          <OrderActions data={data} />
        </StyledTableCell>

        <StyledTableCell align="left">
          <Box sx={{ color: "black", borderBottom: "none", display: "inline-block" }}>
            {data.role}
          </Box>
        </StyledTableCell>

        <StyledTableCell align="left">
          <Box sx={{ color: "black", borderBottom: "none", display: "inline-block" }}>
            {data.moduleType}
          </Box>
        </StyledTableCell>

        <StyledTableCell align="left">
          <Box
            sx={{
              color: getStatusColor(),
              backgroundColor: getStatusColor() + "44",
              padding: "3px 5px",
              borderRadius: 1,
              fontSize: 14,
              minWidth: 80,
              textAlign: "center",
              display: "inline-block",
            }}
          >
            {data.isActive ? "Active" : "Inactive"}
          </Box>
        </StyledTableCell>
      </TableRow>

    </>
  );
};

export default TableItem;
